/**
 * Webform accessibility.
 * @type {{attach: Drupal.behaviors.webformAccessibility.attach}}
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const webformAccessibility_once = once('webform-accessibility-once',
      'form[data-drupal-selector="webform-submission-state-aid-matter-add-form"], ' +
      'form[data-drupal-selector="webform-submission-salary-pension-or-remuneration-add-form"], ' +
      'form[data-drupal-selector="webform-submission-contact-add-form"], ' +
      'form[data-drupal-selector="webform-submission-kontaktformular-finanzamt-add-form"]', context);

    $(webformAccessibility_once).each(function () {
      // Add missing classes to the terms and conditions validation error wrapper.
      let $termsFieldset = $(this).find('fieldset[data-drupal-selector="edit-data-protection"]');

      if ($termsFieldset.length) {
        let $termsFieldsetValidationWrapper = $termsFieldset.find('.fieldset-wrapper > div:first-of-type');

        if (($termsFieldsetValidationWrapper.length) && (typeof $termsFieldsetValidationWrapper.attr('class') === "undefined")) {
          $termsFieldsetValidationWrapper.attr('class', 'form-item--error-message alert alert-danger alert-sm');
        }
      }

      // Add error messages ids and connect them with the fields.
      let idCount = 0;

      $(this).find('.form-item').each(function() {
        let $errorMessage = $(this).find('.form-item--error-message');
        let $field = $(this).find('input');
        if (!$field.length) {
          $field = $(this).find('textarea');
        }

        if (($field.length) && ($errorMessage.length)) {
          idCount++;
          $errorMessage.attr('id', 'error_message_' + idCount);
          $field.attr('aria-describedby', 'error_message_' + idCount)
        }
      });

      // Add autocomplete attributes to the address fields and birthday.
      if (($(this).attr('data-drupal-selector') === 'webform-submission-state-aid-matter-add-form')
        || ($(this).attr('data-drupal-selector') === 'webform-submission-salary-pension-or-remuneration-add-form')) {
        $(this).find('input[data-drupal-selector="edit-address-address"]').attr('autocomplete','street-address');
        $(this).find('input[data-drupal-selector="edit-address-postal-code"]').attr('autocomplete','postal-code');
        $(this).find('input[data-drupal-selector="edit-address-city"]').attr('autocomplete','city');

        let $bdayField = $(this).find('input[data-drupal-selector="edit-date-of-birth"]');
        setTimeout(function() {
          $bdayField.attr('autocomplete','bday');
        }, 400);
      }
    });
  },
}
